import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTradingViewLine: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"trading-view-line"} maskId="square-filled-radius-0-stroke-1-IconTradingViewLine"><path fillRule="evenodd" clipRule="evenodd" d="M23.2008 6.40611L14.1509 18.2572L6.77822 10.9012L1.55345 16.9829L0.794922 16.3313L6.72179 9.43225L14.0491 16.7429L22.4061 5.79919L23.2008 6.40611Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconTradingViewLine;
